export default
{
	icons: [
		{
			name: "blinds",
			x: 1142,
			y: 315
		},
		{
			name: "clock",
			x: 1619,
			y: 86
		},
		{
			name: "whiteboard",
			x: 1728,
			y: 449.05
		},
		{
			name: "drip",
			x: 709,
			y: 329
		},
		{
			name: "breakfast",
			x: 320,
			y: 551.05
		},
		{
			name: "talk2pat",
			x: 501,
			y: 425.05
		},
		{
			name: "exit",
			x: 971,
			y: 950.05
		},
		{
			name: "zweedseBand",
			x: 653,
			y: 530.05
		},
		{
			name: "glasses",
			x: 357,
			y: 546
		},
		{
			name: "medication",
			x: 596,
			y: 498.5
		},
		{
			name: "water",
			x: 205.5,
			y: 539.55
		},
		{
			name: "shower",
			x: 821,
			y: 556.05
		},
		{
			name: "cad",
			x: 566,
			y: 741.05
		}
	],
	objects: [
		{
			name: "clock",
			x: 1582.2,
			y: 0
		},
		{
			name: "whiteboard",
			x: 1546,
			y: 544.35
		}
	]
}